import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Online Scheduling Settings'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Online Scheduling Settings',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/settings/online-scheduling',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
